import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";

import "../Form.scss";
import "react-phone-input-2/lib/style.css";
/* Componente reutilizable con nombre genérico
  -> INPUT TEXT para el manejo de FORMS */
function Input(props) {
  /*  id -> IDENTIFICADOR UNICO PARA EL FORM
      type -> el tipo del input -> {text, email, textArea, password, etc...}
      label -> se refiere al nombre del label que se manejará
      helper -> definido como un apoyo debajo de la casilla del input
      onChange -> para evaluar el cambio cosntante por eventos
      feedback -> feedback en caso haya un error
      ...inputProps para otras propiedades que se puedan ir adquiriendo 
        -> {PLACEHOLDER, VALUE, REQUIRED, DISABLED, PATTERN, ETC...}*/
  const {
    id,
    type = "text",
    color = "primary",
    value,
    label,
    helper,
    feedback,
    onChange,
    errors = false,
    override,
    readOnly,
    ...inputProps
  } = props;

  const [focused, setFocused] = useState(false);

  const handleFocus = (e) => {
    setFocused(true);
  };

  const handleInput = (evt) => {
    if (type === "number") {
      var theEvent = evt || window.evt;

      // Handle paste
      if (theEvent.type === "paste") {
        key = evt.clipboardData.getData("text/plain");
      } else {
        // Handle key press
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
      }
      var regex = /[0-9]|\./;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
    onChange(evt);
  };

  return (
    <>
      {label && (
        <label className="form-label text-primary">
          <h4>{label}</h4>
        </label>
      )}
      {type === "tel" ? (
        <PhoneInput
          id={id}
          value={value}
          className={`text-primary border-${color}`}
          country={"pe"}
          onChange={onChange}
          onBlur={handleFocus}
          focused={!errors ? focused.toString() : "true"}
          {...inputProps}
        />
      ) : (
        <input
          id={id}
          type={
            type === "number" ? "text" : type
          } /* {text, email, textArea, password, etc...} */
          value={value}
          className={`form-control text-primary border-${color} override-${override} ${
            readOnly && "input-read-only"
          }`}
          onChange={onChange}
          onKeyPress={handleInput}
          onBlur={handleFocus}
          readOnly={readOnly}
          focused={!errors ? focused.toString() : "true"}
          {...inputProps}
        />
      )}
      {helper && (
        <div
          id={`helper_${id}`}
          className={`form-text ${feedback && "valid-div"}`}
        >
          <p className="text-dark">{helper}</p>
        </div>
      )}
      {feedback && (
        <div
          id={`helperror_${id}`}
          className="form-text invalid-feedback invalid-div"
        >
          <p className="text-danger">{feedback}</p>
        </div>
      )}
      {!helper && (
        <div
          id={`none_${id}`}
          className={`margin-bottom ${feedback && "valid-div"}`}
        ></div>
      )}
    </>
  );
}

export default Input;
